export default "__VITE_PUBLIC_ASSET__bb814c89__"